
import {ExportRegistry} from "./ExportRegistry.js";

// DXF and SHP graduated from stubs to real exporters - see
// DXFFeatureExporter.js/ShapefileFeatureExporter.js. Nothing is registered
// from this file any more; `stub()` is kept available (unexported →
// exported below only if/when a future format genuinely needs the
// disabled-"coming soon"-placeholder pattern again) rather than deleted,
// since it's the established, working convention for "visibly part of the
// architecture without pretending to work yet" - see ExportRegistry.js's
// own header comment. No format is currently registered this way.
export function stub(id, name, extension){
	return {
		id,
		name,
		extension,
		disabled: true,
		export(){
			throw new Error(`${name} export is not yet implemented - the architecture is reserved for a future exporter.`);
		},
	};
}
